<template>
  <div class="py-3 flex justify-center branding--background">
    <a
      :href="brandRedirectURL"
      rel="noreferrer noopener nofollow"
      target="_blank"
      class="branding--frame justify-center"
    >
      <!-- <span class="branding--textfooter">
        {{   class="branding--frame justify-center"
          useInstallationName($t('POWERED_BY'), (globalConfig.brandName = ''))
        }}
      </span> -->
      <span class="branding--textfooter">
        Supported By
      </span>

      <img
        class="branding--image"
        src="~/widget/assets/images/Voca - logo.svg"
      />
    </a>
  </div>
  <!-- <div v-else class="p-3" /> :src="globalConfig.logoThumbnail" -->
</template>

<script>
import globalConfigMixin from 'shared/mixins/globalConfigMixin';

const {
  LOGO_THUMBNAIL: logoThumbnail,
  BRAND_NAME: brandName,
  WIDGET_BRAND_URL: widgetBrandURL,
} = window.globalConfig || {};

export default {
  mixins: [globalConfigMixin],
  props: {
    disableBranding: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      globalConfig: {
        brandName,
        logoThumbnail,
        widgetBrandURL,
      },
    };
  },
  computed: {
    brandRedirectURL() {
      try {
        // const referrerHost = this.$store.getters['appConfig/getReferrerHost'];
        // const baseURL = `${this.globalConfig.widgetBrandURL}?utm_source=${
        //   referrerHost ? 'widget_branding' : 'survey_branding'
        //   }`;
        const baseURL =
          'https://www.audiocodes.com/solutions-products/voiceai/voca-conversational-interaction-center';
        // if (referrerHost) {
        //   return `${baseURL}&utm_referrer=${referrerHost}`;
        // }
        return baseURL;
      } catch (e) {
        // Suppressing the error as getter is not defined in some cases
      }
      return '';
    },
  },
};
</script>

<style scoped lang="scss">
@import '~widget/assets/scss/variables.scss';

.branding--background {
  background: var(--light-light-system-colors-background, #f6f6f9);
}
.branding--frame {
  // display: flex;
  // flex-direction: row;
  // justify-content: center;
  // align-items: center;
  // padding: 0px;
  // gap: 9px;

  display: flex;
  flex-direction: row;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 9px;

  width: 126px;
  height: 20px;

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
}

.branding--textfooter {
  color: #8e8ea9;

  height: 20px;

  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  /* identical to box height, or 167% */

  letter-spacing: 0.5px;

  /* Light Light  SystemColors/Header, Icons  */

  // color: #8e8ea9;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}
.branding--image {
  width: 50px;
  height: 12px;

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 1;
}
.branding--link {
  // color: $color-light-gray;
  // cursor: pointer;
  // display: inline-flex;
  // filter: grayscale(1);
  // font-size: $font-size-small;
  // opacity: 0.9;
  // text-decoration: none;

  // filter: grayscale(0);
  // opacity: 1;
  // color: $color-gray;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 9px;
}
</style>
